import { useTranslation } from 'react-i18next';

import { ModalComponent } from '@Components';
import { TrackedButton } from '@Components/ui-v2/tracked-button';

interface ConfirmationProvider {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  confirmText: string;
  buttonNamePrefix: string;
  confirmButtonText?: string;
}

const ConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  confirmText,
  buttonNamePrefix,
  confirmButtonText,
}: ConfirmationProvider) => {
  const { t } = useTranslation();

  return (
    <ModalComponent isOpen={isOpen} onClose={onClose} title="">
      <div className="flex flex-col">
        <span className="text-gray-700 text-center">{confirmText}</span>
        <div className="flex gap-2 justify-center mt-8">
          <TrackedButton
            variant="outline"
            buttonName={`${buttonNamePrefix}_CONFIRMATION_MODAL_CANCELED`}
            onClick={onClose}
            isSubmit={false}
            className="w-full bg-white">
            {t('Global.Canceled')}
          </TrackedButton>

          <TrackedButton
            buttonName={`${buttonNamePrefix}_CONFIRMATION_MODAL_CONFIRMED`}
            onClick={onConfirm}
            isSubmit={false}
            className="w-full">
            {confirmButtonText ?? t('Global.Confirm')}
          </TrackedButton>
        </div>
      </div>
    </ModalComponent>
  );
};

export default ConfirmationModal;
